<template>
  <div class="h-80 flex flex-col items-center justify-center gap-3 text-base-content/40 select-none">
    <i class="bi bi-bar-chart-line text-4xl"></i>
    <p class="text-sm font-medium">No data available</p>
    <p class="text-xs">Data will appear here once activity is recorded.</p>
  </div>
</template>
